function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];
 
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }
 
    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });
 
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');
 
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));
 
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;
      const newValue = Math.max(quantity + change, 1);
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;
      this.input.value = newValue;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }
 
    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }
 
  customElements.define('quantity-selector', QuantityInput);
}
 
/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, { passive: true });
        image_container.addEventListener('touchmove', mousemove, { passive: true });
        image_container.addEventListener('touchend', mouseleave, { passive: true });
        image_container.addEventListener('mouseenter', mousemove, { passive: true });
        image_container.addEventListener('mousemove', mousemove, { passive: true });
        image_container.addEventListener('mouseleave', mouseleave, { passive: true });
      }
 
      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';
 
      this.addEventListener('change', this.onSwatchChange.bind(this));
 
      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.disabled = true;
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);
 
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
 
      let formData = new FormData();
      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
 
      config.body = formData;
 
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.disabled = false;
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });
 
      return false;
    }
    getSectionsToRender() {
      return [
        { id: 'Cart',               section: 'main-cart',   selector: '.thb-cart-form' },
        { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
 
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}
 
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
 
    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
 
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }
 
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');
        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);
 
  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
 
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
 
    constructor() {
      super();
    }
 
    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');
 
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
 
      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });
 
      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.removeProductEvent();
      document.addEventListener('click', this.onWindowClick.bind(this));
 
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });
 
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }
 
    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');
      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [
        { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer--inner' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
      ];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
 
      dispatchCustomEvent('line-item:change:start', { quantity: quantity });
 
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        ...{ body }
      })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
 
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));
 
          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', { quantity: quantity, cart: parsedState });
 
          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
 
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));
 
          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}
 
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
 
/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }
 
    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;
 
      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}
 
/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;
 
      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
 
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, { method: 'GET' })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;
 
        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');
 
        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }
 
        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);
 
        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();
 
        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');
          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);
 
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}
 
/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();
 
      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});
 
      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;
 
      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);
 
      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav?.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });
 
        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;
          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}
 
/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();
 
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');
 
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
 
      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = 'hidden';
 
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;
 
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
 
      if (this.animation) {
        this.animation.cancel();
      }
 
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });
 
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
 
    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
 
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
 
      if (this.animation) {
        this.animation.cancel();
      }
 
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
 
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
 
    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
 
      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
 
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');
    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
 
  var i = window.recentlyViewedIds.indexOf(handle);
  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }
 
  window.recentlyViewedIds.unshift(handle);
 
  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}
 
document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});
 
/**
 *  Variant Dropdown — add to cart with full UI update
 *  Moves the list to <body> when open so overflow:hidden containers don't clip it
 */

function openVariantDropdown(dropdown) {
  if (!dropdown.dataset.dropdownId) {
    dropdown.dataset.dropdownId = 'vd-' + Date.now();
  }

  const toggleBtn = dropdown.querySelector('.variant-toggle');
  const list = dropdown.querySelector('.variant-list');
  const rect = toggleBtn.getBoundingClientRect();

  list.dataset.dropdownId = dropdown.dataset.dropdownId;

  list.style.cssText = [
    'position: fixed',
    'top: ' + rect.bottom + 'px',
    'left: ' + rect.left + 'px',
    'width: ' + Math.max(rect.width, 220) + 'px',
    'z-index: 9999',
    'display: block',
    'background: #fff',
    'border: 1px solid #ddd',
    'box-shadow: 0 4px 12px rgba(0,0,0,0.12)',
    'max-height: 60vh',
    'overflow-y: auto'
  ].join(';');

  document.body.appendChild(list);
  dropdown.classList.add('open');
}

function closeAllVariantDropdowns() {
  document.querySelectorAll('body > .variant-list').forEach(function (list) {
    var dropdownId = list.dataset.dropdownId;
    var dropdown = document.querySelector('.variant-dropdown[data-dropdown-id="' + dropdownId + '"]');
    list.style.cssText = '';
    if (dropdown) {
      dropdown.appendChild(list);
    } else {
      list.remove();
    }
  });

  document.querySelectorAll('.variant-dropdown.open').forEach(function (el) {
    el.classList.remove('open');
  });
}

document.addEventListener('click', function (e) {

  // Toggle dropdown open/close
  if (e.target.closest('.variant-toggle')) {
    var dropdown = e.target.closest('.variant-dropdown');
    var isOpen = dropdown.classList.contains('open');
    closeAllVariantDropdowns();
    if (!isOpen) {
      openVariantDropdown(dropdown);
    }
    return;
  }

  // Handle variant option click
  if (e.target.closest('.variant-option')) {
    var btn = e.target.closest('.variant-option');
    var variantId = btn.dataset.variantId;
    var list = btn.closest('.variant-list');
    var dropdownId = list ? list.dataset.dropdownId : null;
    var dropdown = dropdownId
      ? document.querySelector('.variant-dropdown[data-dropdown-id="' + dropdownId + '"]')
      : btn.closest('.variant-dropdown');

    closeAllVariantDropdowns();

    if (!dropdown) return;

    var toggleBtn = dropdown.querySelector('.variant-toggle');
    var originalText = toggleBtn.textContent;
    toggleBtn.textContent = 'Adding...';
    toggleBtn.disabled = true;

    var sectionsToRender = [
      { id: 'Cart',               section: 'main-cart',   selector: '.thb-cart-form' },
      { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
    ];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', sectionsToRender.map(function (s) { return s.section; }));
    formData.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('Add to cart error:', response.description);
          return;
        }

        sectionsToRender.forEach(function (section) {
          var container = document.getElementById(section.id);
          if (!container) return;
          var el = container.querySelector(section.selector) || container;
          var html = new DOMParser()
            .parseFromString(response.sections[section.section], 'text/html')
            .querySelector(section.selector);
          if (html) el.innerHTML = html.innerHTML;
        });

        var cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer) {
          cartDrawer.open();
          cartDrawer.removeProductEvent();
        }

        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      })
      .catch(function (err) { console.error('Variant add to cart failed:', err); })
      .finally(function () {
        toggleBtn.textContent = originalText;
        toggleBtn.disabled = false;
      });

    return;
  }

  // Close dropdown when clicking outside
  var openList = document.querySelector('body > .variant-list');
  if (openList && !openList.contains(e.target) && !e.target.closest('.variant-toggle')) {
    closeAllVariantDropdowns();
  }

});

// Close on scroll so the dropdown doesn't float away from its button
window.addEventListener('scroll', function () {
  closeAllVariantDropdowns();
}, { passive: true });